import { render, staticRenderFns } from "./CareLogin.vue?vue&type=template&id=2a8c4dfa&"
import script from "./CareLogin.vue?vue&type=script&lang=js&"
export * from "./CareLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports